// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUserCheck, IconBasket, IconMessages, 
    IconLayoutKanban, IconMail, IconCalendar, 
    IconNfc,
    IconBook,
    IconUserCircle 
} from "@tabler/icons-react"

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const formulesPoints = {
    id: 'calcules_points1',
    title: ["F. ",<FormattedMessage id="calcules_points" />],
    type: 'group',
    icon: <IconLayoutKanban />, // Use a valid icon component here
    children: [
       
           
               /*  {
                    id: 'baseCalculsPoint1',
                    title: ["1. ", <FormattedMessage id="baseCalculsPoint1" />],
                    type: 'item',
                    url: '/formules/BaseCalculPoints'
                },  */

                {
                    id: 'caklendario_lancamento_notas1',
                    title: ["1. ",<FormattedMessage id="calendario_lancamento_notas" />],
                    type: 'item',
                    url: '/formules/CalendarExame'
                }, 

                {
                    id: 'avaliations_realise1',
                    title: ["2. ", <FormattedMessage id="avaliations_realise" />],
                    type: 'item',
                    url: '/formules/TypoExamesEAvaliationsSchool'
                },

                

                /* {
                    id: 'arredondarTotal1',
                    title: ["3. ", <FormattedMessage id="arrendondar_totais" />],
                    type: "item",
                    url: '/formules/DiversConfigurationArrendondarTotal'
                  }, */

                 /*  {
                    id: 'avaliations_realise1',
                    title: ["4. ", <FormattedMessage id="avaliations_realise" />],
                    type: 'item',
                    url: '/formules/TypoExamesEAvaliations'
                }, */

                  /* {
                    id: 'dispenses_text1',
                    title: ["5. ", <FormattedMessage id="dispenses_text" />],
                    type: 'item',
                    url: '/formules/MentionDispensaAntesExame'
                }, */
               /*  {
                    id: 'dispensesDepois_text1',
                    title: ["6. ", <FormattedMessage id="dispensesDepois_text" />],
                    type: 'item',
                    url: '/formules/MentionDispensaaDepoisExame'
                }, */

               /*  {
                    id: 'formuleCalculPoints1',
                    title: ["7. ", <FormattedMessage id="dispenseRecours_text" />],
                    type: 'item',
                    url: '/formules/MentionDispensaaDepensaRecourso'
                },  
 */
              /*   {
                    id: 'resultado_equivalencia_exame_especial1',
                    title: ["8. ",<FormattedMessage id="resultado_equivalencia_exame_especial" />],
                    type: 'item',
                    url: '/formules/MentionEquivalenciaExameEspecial'
                },  */ 

                

                {
                    id: 'formuleCalculPoints1',
                    title: ["3. ", <FormattedMessage id="formula_avaliation_Antes_exame_menu_ecoles" />],
                    type: 'item',
                    url: '/formules/FormulesCalculPointsConditionsEcolesTrimestres'
                },  

                {
                    id: 'formuleCalculPoints1',
                    title: ["3. ", <FormattedMessage id="formula_avaliation_Antes_exame_menu_ecoles_Semestre" />],
                    type: 'item',
                    url: '/formules/FormulesCalculPointsConditionsEcoles'
                },  

                {
                    id: 'mentions_deliberation1',
                    title: ["4. ", <FormattedMessage id="formula_avaliation_Antes_exame_menu_ecoles_Semestre" />],
                    type: 'item',
                    url: '/formules/MentionPourcentageEcoles'
                },

               /*  {
                    id: 'formuleCalculPoints1',
                    title: ["4. ", <FormattedMessage id="formula_avaliation_Antes_exame_menu" />],
                    type: 'item',
                    url: '/formules/FormulesCalculPointsConditionsEcoles'
                },   */

                
               /*  {
                    id: 'mentions_deliberation1',
                    title: ["4. ", <FormattedMessage id="FormulesCalculPointsConditionsEcolesSemestres" />],
                    type: 'item',
                    url: '/formules/FormulesCalculPointsConditionsEcolesSemestres'
                }, */
    
            ]
};

export default formulesPoints;
